module.exports = __webpack_public_path__ + "static/media/5_11.1338874e.png";